<template>
  <div>
    <div v-if="cargando">
      <v-progress-linear indeterminate color="primary"></v-progress-linear>
      <v-container>
        <v-row justify="center">
          <v-col sm="12" md="12" lg="12" xl="12">
            <p class="font-weight-black titlesdark--text text-center display-1">{{ sTitle }}</p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-container v-if="!cargando" class="pa-0">
        <v-row dense align="center" justify="center">
          <v-col sm="12" md="12" lg="12" xl="12">
            <v-btn width="100%" text small color="btncolor" @click="printSection()" dark> 
              <span class="font-weight-bold title">Exportar</span> 
              <v-icon small right dark>fa-chevron-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
    </v-container>
    <div id="printPage" style="background: #FFFFFF;">
      <v-container v-if="!cargando" class="imprimir">
        <v-row dense justify="center">
          <v-col sm="2" md="2" lg="2" xl="2">
            <div id="sImgReference" style="border: 1px; text-align: center;">
              <img id="Logo" style="width: 150px; height: 150px;" :src="LogoImageURL"/>
            </div>
          </v-col>
          <v-col sm="10" md="10" lg="10" xl="10">
            <v-banner
              class="bnrHead"
              min-height="100">
              <div v-for="(oDataHead, i) in aDataHead" :key="i" >
                <span class="title font-weight-bold" style="color: white;">{{ i }}&nbsp;&nbsp;</span><span class="title" style="color: white;">{{ oDataHead }}</span>
                <br>
              </div>
            </v-banner>
            <v-container fluid>
              <v-row dense align="center" justify="center">
                <v-col sm="6" md="6" lg="6" xl="6">
                  <span class="title ntitlesdark--text pl-1 text-center">Fecha reporte: {{ Fecha }}</span>
                </v-col>
                <v-col sm="6" md="6" lg="6" xl="6">
                  <span class="title ntitlesdark--text pl-1 text-center">Version: R001</span>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-if="!cargando" class="imprimir">
        <v-row justify="center" align="center" dense>
          <v-col sm="12" md="12" lg="12" xl="12">
            <v-banner
              width="100%"
              color="#CCCCCC">
              <div width="100%">
                <h2 class="font-weight-bold ntitlesdark--text text-center">Informe de gestión de riesgos</h2>
              </div>
            </v-banner>
          </v-col>
        </v-row>
        <v-row v-if="aElement.includes('1') || aElement.includes('2') || aElement.includes('3') || aElement.includes('6')">
          <v-col v-for="(oDataCard, i) in aDataCard" :key="i" sm="3" md="3" lg="3" xl="3">
            <Cards
              :aData="oDataCard">
            </Cards>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-if="!cargando && aElement.includes('4')">
        <div class="imprimir">
          <v-row justify="center" align="center" dense>
            <v-col sm="12" md="12" lg="12" xl="12">
              <v-banner
                width="100%"
                color="#CCCCCC">
                <div width="100%">
                  <h2 class="font-weight-bold ntitlesdark--text text-center">Evaluación de riesgos</h2>
                </div>
              </v-banner>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <v-col sm="12" md="12" lg="12" xl="12">
            <Grid
              :oTablas="oTablesGrid1"
              :sIndicaSeccion="'4'">
            </Grid>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-if="!cargando && aElement.includes('5')">
        <div v-for="(oTypeMatriz, i) in aTypeMatriz" :key="i" class="imprimir">
          <v-row justify="center" align="center" dense>
            <v-col sm="12" md="12" lg="12" xl="12">
              <v-banner
                width="100%"
                color="#CCCCCC">
                <div width="100%">
                  <h2 class="font-weight-bold ntitlesdark--text text-center">Matriz de riesgos Inicial (Criterio de impacto {{ oTypeMatriz.Titulo }})</h2>
                </div>
              </v-banner>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12" md="12" lg="8" xl="8">
              <Matriz
                :sType="'Inicial'"
                :nIdCriterio="oTypeMatriz.ID">
              </Matriz>
            </v-col>
            <v-col sm="12" md="12" lg="4" xl="4">
              <ListRisk
                :sType="'Inicial'"
                :nIdCriterio="oTypeMatriz.ID">
              </ListRisk>
            </v-col>
          </v-row>
          <v-row justify="center" align="center" dense>
            <v-col sm="12" md="12" lg="12" xl="12">
              <v-banner
                width="100%"
                color="#CCCCCC">
                <div width="100%">
                  <h2 class="font-weight-bold ntitlesdark--text text-center">Matriz de riesgos Actual (Criterio de impacto {{ oTypeMatriz.Titulo }})</h2>
                </div>
              </v-banner>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12" md="12" lg="8" xl="8">
              <Matriz
                :sType="'Actual'"
                :nIdCriterio="oTypeMatriz.ID">
              </Matriz>
            </v-col>
            <v-col sm="12" md="12" lg="4" xl="4">
              <ListRisk
                :sType="'Actual'"
                :nIdCriterio="oTypeMatriz.ID">
              </ListRisk>
            </v-col>
          </v-row>
        </div>
        <div class="imprimir">
          <v-row>
            <v-col sm="12" md="12" lg="12" xl="12">
              <Convenciones></Convenciones>
            </v-col>
          </v-row>
        </div>
      </v-container>
      <v-container v-if="!cargando && aElement.includes('7')">
        <div class="imprimir">
          <v-row justify="center" align="center" dense>
            <v-col sm="12" md="12" lg="12" xl="12">
              <v-banner
                width="100%"
                color="#CCCCCC">
                <div width="100%">
                  <h2 class="font-weight-bold ntitlesdark--text text-center">Controles Realizados</h2>
                </div>
              </v-banner>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <v-col sm="12" md="12" lg="12" xl="12">
            <Grid
              :oTablas="oTablesGrid2"
              :sIndicaSeccion="'7'">
            </Grid>
          </v-col>
        </v-row>
        <div class="imprimir">
          <v-row>
            <v-col sm="12" md="12" lg="12" xl="12">
              <Graficas
                sTitle="Recomendaciones"
                :sTypeChart="'ColumnChart'"
                :sSection="'7'">
              </Graficas>
            </v-col>
          </v-row>
        </div>
      </v-container>
      <v-container v-if="!cargando && aElement.includes('8')">
        <div class="imprimir">
          <v-row v-if="!cargando && aElement.includes('9')">
            <v-col sm="12" md="12" lg="12" xl="12">
              <Graficas
                sTitle="Historico Marcaciones"
                :sTypeChart="'BarChart'"
                :sSection="'9'">
              </Graficas>
            </v-col>
          </v-row>
          <v-row v-if="!cargando && aElement.includes('10')">
            <v-col sm="12" md="12" lg="12" xl="12">
              <Graficas
                sTitle="Registro mes anterior"
                :sTypeChart="'LineChart'"
                :sSection="'10'">
              </Graficas>
            </v-col>
          </v-row>
        </div>
        <div class="imprimir">
          <v-row justify="center" align="center" dense>
            <v-col sm="12" md="12" lg="12" xl="12">
              <v-banner
                width="100%"
                color="#CCCCCC">
                <div width="100%">
                  <h2 class="font-weight-bold ntitlesdark--text text-center">Gestión Vecinos</h2>
                </div>
              </v-banner>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <v-col sm="12" md="12" lg="12" xl="12">
            <Grid
              :oTablas="oTablesGrid3"
              :sIndicaSeccion="'4'">
            </Grid>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-dialog v-model="bShowExport" persistent width="250">
      <v-card
        color="primary"
        dark>
        <v-card-title>
          Generando PDF...
        </v-card-title>
        <v-card-text style="text-align: center;">
          <v-progress-circular
            active
            indeterminate
            color="white"
            class="mb-0">
          </v-progress-circular>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axiosServices from '@/services/axiosServices.js'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { mapGetters } from 'vuex'
import Grid from '@/components/Reportes/Componentes/Grid.vue'
import Cards from '@/components/Reportes/Componentes/CardsTotal.vue'
import Matriz from '@/components/Reportes/Componentes/MatrizRiesgos.vue'
import ListRisk from '@/components/Reportes/Componentes/ListaRiesgos.vue'
import Convenciones from '@/components/Reportes/Componentes/Convenciones.vue'
import Graficas from '@/components/Reportes/Componentes/Graficas.vue'
export default {
  components: {
    Grid,
    Cards,
    Matriz,
    ListRisk,
    Convenciones,
    Graficas
  },
  data() {
    return {
      widthColConvencion: 0,
      sTitle: 'Generando informe...',
      cargando: false,
      Fecha: '',
      sLogoImg: '',
      LogoImageURL: '',
      aDataHead: [],
      aDataCard: [],
      aElement: [],
      aTypeMatriz: [],
      oTablesGrid1: {
        Master: 'RiesgoNovedades',
        Second: 'RiesgoRiesgosNovedad',
        Three: 'RiesgoAnexosNovedades'
      },
      oTablesGrid2: {
        Master: 'RiesgoRiesgosNovedad',
        Second: 'RiesgoRecomendacion',
        Three: ''
      },
      oTablesGrid3: {
        Master: 'VECINOS',
        Second: '',
        Three: 'VECINOS_Anexos'
      },
      bShowExport: false
    }
  },
  mounted() {
    this.getLogo()
    this.getHeader()
    this.getDataCards()
    this.getTitleMatriz()
    this.getElements()
  },
  methods: {
    getElements () {
      let aParams = this.getsParams.split('&')
      var aGet = {}
      // recorremos todo el array de valores
      for(var i = 0, l = aParams.length; i < l; i++){
        var tmp = aParams[i].split('=')
        aGet[tmp[0]] = unescape(decodeURI(tmp[1]))
      }
      this.aElement = aGet['elementos'].split(';')
      this.Fecha = `${aGet['desde']} - ${aGet['hasta']}`
    },
    getLogo () {
      this.cargando = true
      let sParams = 'sPath=LogoImagen'
      axiosServices.getConfiguration('FormDinamicCorreo_Path', false, sParams).then(getPath => {
        this.sLogoImg = getPath.aData.Observacion
        this.proccessData()
      })
    },
    getHeader () {
      this.cargando = true
      axiosServices.getConfiguration(`InformeRiesgos_Header`, false, '').then(getHeader => {
        this.aDataHead = getHeader.aData
      })
    },
    getDataCards () {
      this.cargando = true
      axiosServices.getConfiguration(`InformeRiesgos_Cards`, false, '').then(getCards => {
        this.aDataCard = getCards.aData
        this.cargando = false
      })
    },
    getTitleMatriz () {
      this.cargando = true
      axiosServices.getConfiguration(`InformeRiesgos_Titles`, false, '').then(getTitle => {
        this.aTypeMatriz = getTitle.aData
        this.cargando = false
      })
    },
    async printSection() {
      this.bShowExport = true
      let opentables = document.getElementsByClassName('for-export')
      for (var i = 0; i < opentables.length; i++) {
        opentables[i].style.display = "table-row"
        opentables[i].style["text-align"] = "center"
      }
      let elements = document.querySelectorAll("#printPage .imprimir")
      var doc = new jsPDF('p', 'mm', 'a4', true)
      doc.setFillColor(245);
      doc.rect(0, 0, 210, 700, "F");
      var imgWidth = doc.internal.pageSize.getWidth()
      var pageHeight = doc.internal.pageSize.getHeight()
      var position = 5
      var pageHeightLeft = pageHeight
      for (let i = 0; i < elements.length; i++) {
        await html2canvas(elements[i], {
          scale: 2,
          useCORS: true,
          allowTaint: true
        }).then(function(canvas) {
          let imgData = canvas.toDataURL('image/png', 1.0)
          var imgHeight = canvas.height * imgWidth / canvas.width
          // Comprobamos salto
          if (pageHeightLeft - imgHeight <= 0) {
            doc.addPage();
            pageHeightLeft = pageHeight
            position = 5; // Pintaremos en el inicio de la nueva pagina
          }
          doc.addImage(imgData, 'PNG', 0, position, (imgWidth - 3), imgHeight)
          position += imgHeight; // Marcamos el siguiente inicio
          pageHeightLeft -= imgHeight; // Marcamos cuanto espacio nos queda
        })
      }
      // const sNameFile = new Date().toISOString().substr(0, 10)
      doc.save(`Informe de seguridad ${this.Fecha}.pdf`)
      this.bShowExport = false
    },
    toDataURL (src, callback) {
      var img = new Image()
      img.crossOrigin = 'Anonymous'
      img.onload = function() {
        var canvas = document.createElement('canvas')
        var context = canvas.getContext('2d')
        canvas.height = this.naturalHeight
        canvas.width = this.naturalWidth
        context.drawImage(this, 0, 0)
        var dataURL = canvas.toDataURL('image/jpeg', 1.0)
        callback(dataURL)
      }
      img.src = src
    },
    proccessData () {
      this.toDataURL(`${this.sLogoImg}`, this.setValue)
    },
    setValue (sBase64) {
      this.LogoImageURL = sBase64
    },
    resize () {
      if (window.addEventListener) {  // all browsers except IE before version 9
        window.addEventListener("resize", onResizeEvent, true);
      }
      function onResizeEvent() {
        let divImgElement = document.getElementById("sImgReference")
        let newWidth = divImgElement.clientWidth
        let oImgRender = document.getElementById("Logo")
        oImgRender.style.width = `${newWidth}px`
        oImgRender.style.height = `${newWidth}px`
      }
    },
  },
  computed: {
    ...mapGetters([
      'getsParams'
    ])
  },
  watch: {
    cargando(oNew) {
      if (oNew === false) {
        this.resize()
      }
    }
  },
}
</script>
<style>
  .bnrHead {
    background-image: linear-gradient(to bottom, #15adc7, #0089b5, #00659e, #004281, #011f5f);
  }
  .v-banner__content {
    overflow: visible !important;
  }
  .v-banner__text {
    line-height: 20px;
    width: 100% !important;
  }
</style>